/* eslint-disable @typescript-eslint/naming-convention */
import { History } from "history";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { ApplicationState } from "../../../store";
import {
  findMany,
  selectCardPrompt,
} from "../../../store/cardPrompt/cardPromptSlice";
import { CardPromptType } from "../../../store/cardPrompt/types";
import PageLayout from "../../PageLayout";
import { MRT_ColumnDef, MaterialReactTable } from "material-react-table";
import TableActions from "../../../common/table/TableActions";

interface RowData {
  id: string;
  name?: string;
}

const CardPrompt = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const { loading, entries } = useSelector(
    (store: ApplicationState) => store.cardPrompt
  );

  useEffect(() => {
    dispatch(findMany());
  }, []);

  const pageActions = [
    {
      label: "Add new Card Prompt",
      handler: (history: History) => {
        const newPrompt: CardPromptType = {
          id: undefined,
          type: "CardPrompts",
          attributes: {
            Name: "",
            Bin: [],
          },
        };
        dispatch(selectCardPrompt({ cardPrompt: newPrompt }));
        return history.push("/cardPrompt/new");
      },
    },
  ];

  const viewAction = (rowData: RowData) => {
    const cardPrompt = entries.find((entry) => entry.id === rowData.id);
    dispatch(selectCardPrompt({ cardPrompt }));
    history.push(`/cardPrompt/view/${rowData.id}`);
  };

  const editAction = (rowData: RowData) => {
    const cardPrompt = entries.find((entry) => entry.id === rowData.id);
    dispatch(selectCardPrompt({ cardPrompt }));
    history.push(`/cardPrompt/edit/${rowData.id}`);
  };

  const data = useMemo(
    () =>
      entries
        ? entries.map((entry) => ({
            id: entry.id,
            name: entry.attributes.Name,
          }))
        : [],
    [entries]
  );

  const columns = useMemo<MRT_ColumnDef<RowData>[]>(
    () => [
      {
        header: "Name",
        accessorKey: "name",
      },
    ],
    []
  );

  return (
    <PageLayout
      heading="Card Prompts"
      loading={loading}
      actions={pageActions}
      entity="CardPrompts"
    >
      <MaterialReactTable
        columns={columns}
        data={data}
        getRowId={(row) => row.id}
        initialState={{
          showGlobalFilter: true,
          showColumnFilters: false,
          density: "spacious",
        }}
        enableColumnActions={false}
        enableDensityToggle={false}
        enableFullScreenToggle={false}
        enableColumnFilters={false}
        enableHiding={false}
        enableRowActions
        muiTablePaginationProps={{
          rowsPerPageOptions: [5, 10, 20],
        }}
        displayColumnDefOptions={{
          "mrt-row-actions": {
            header: "",
            size: 100,
          },
        }}
        positionActionsColumn="last"
        renderRowActions={({ row }) => (
          <TableActions
            section="CardPrompts"
            onView={() => viewAction(row.original)}
            onEdit={() => editAction(row.original)}
          />
        )}
      />
    </PageLayout>
  );
};

export default CardPrompt;
